// extracted by mini-css-extract-plugin
export var menuIn = "nav-module--menu-in--HCEP-";
export var navAskMeAnything = "nav-module--navAskMeAnything--L3NIC";
export var navCareerDev = "nav-module--navCareerDev--OE40F";
export var navChild = "nav-module--navChild--ejasu";
export var navChildLink = "nav-module--navChildLink--YT7QM";
export var navChildLinkActive = "nav-module--navChildLinkActive--PGnlX";
export var navChildLinkDots = "nav-module--navChildLinkDots---F-x7";
export var navChildren = "nav-module--navChildren--dLdnw";
export var navChildrenContainer = "nav-module--navChildrenContainer--vsaMe";
export var navChildrenDots = "nav-module--navChildrenDots--yZlRb";
export var navChildrenDotsChild = "nav-module--navChildrenDotsChild--uO1aK";
export var navFamilies = "nav-module--navFamilies--f-ge2";
export var navHome = "nav-module--navHome--eCQnD";
export var navIndustries = "nav-module--navIndustries--MPOan";
export var navItem = "nav-module--navItem--M9AMs";
export var navItemHasChildren = "nav-module--navItemHasChildren--epqsN";
export var navItemIcon = "nav-module--navItemIcon--lMWLg";
export var navItemIconDots = "nav-module--navItemIconDots--KAWW2";
export var navItemIconNotify = "nav-module--navItemIconNotify--ueP1X";
export var navItemLink = "nav-module--navItemLink--sWzQS";
export var navItemLinkActive = "nav-module--navItemLinkActive--ha2kr";
export var navItemLinkActiveDots = "nav-module--navItemLinkActiveDots--VwiiA";
export var navItemLinkDots = "nav-module--navItemLinkDots--tQc8u";
export var navItemLinkHighlight = "nav-module--navItemLinkHighlight--yjAzh";
export var navItemLinkHighlightDots = "nav-module--navItemLinkHighlightDots--Rm3ur";
export var navItemText = "nav-module--navItemText--fa1IY";
export var navItems = "nav-module--navItems--O-KB0";
export var navProfile = "nav-module--navProfile--gAvPT";
export var navSkillsExplorer = "nav-module--navSkillsExplorer--kQG7P";
export var navThreeDots = "nav-module--navThreeDots--AnPNk";
export var root = "nav-module--root--5lsvJ";
export var spanSubtitle = "nav-module--spanSubtitle--ThcOq";